<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 20 19"
    style="enable-background:new 0 0 19.8 20.4;"
    fill="none"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_dashboard">
      <path
        id="Rectangle 20"
        d="M4.6001 17.2V18.1H14.5001V17.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect id="Rectangle 19" x="1" y="1" width="18" height="14.4" rx="1" stroke-linejoin="round" />
      <path id="Vector 15" d="M5.5 10L5.5 12.7" stroke-linecap="round" />
      <path id="Vector 19" d="M9.1001 4.59998H3.7001" stroke-linecap="round" />
      <path id="Vector 20" d="M7.2998 6.40002H3.6998" stroke-linecap="round" />
      <path id="Vector 16" d="M7.2998 10.9L7.2998 12.7" stroke-linecap="round" />
      <path id="Vector 18" d="M3.7002 10.9L3.7002 12.7" stroke-linecap="round" />
      <circle id="Ellipse 43" cx="14.5002" cy="5.50001" r="1.8" />
      <circle id="Ellipse 44" cx="14.5002" cy="10.9" r="1.8" />
    </g>
  </svg>
</template>
<style scoped>
.icon-dashboard {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-dashboard"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>